// The dashboard's read endpoints (row S38) over the generated client. A host whose ocs-api
// predates them answers 404, which every widget shows as an empty state.
//
// Their query parameters (`days`, `limit`, `status`) are declared in the path by the schema,
// like `limit` on the runs list (api/queries.ts), so openapi-fetch drops them and the server
// defaults apply; those defaults are what the dashboard wants: 30 days, 20 calls, pending.
import { queryOptions } from "@tanstack/react-query";

import { api, type Schemas } from "../api/client";
import { unwrap } from "../api/queries";

export type HostCapacity = Schemas["HostCapacityDto"];
export type ModelUsage = Schemas["ModelUsageDto"];
export type BrokerCall = Schemas["BrokerCallDto"];
export type PendingQuestion = Schemas["OpenQuestionDto"];

// Each refetches on an interval: the dashboard is a page people leave open.
export const capacityQuery = () =>
  queryOptions({
    queryKey: ["host", "capacity"],
    queryFn: () => unwrap(api.GET("/api/host/capacity")),
    refetchInterval: 30_000,
    retry: false,
  });

export const usageQuery = (orgId: string) =>
  queryOptions({
    queryKey: ["orgs", orgId, "usage", "model"],
    queryFn: () => unwrap(api.GET("/api/orgs/{org_id}/usage/model", { params: { path: { org_id: orgId, days: null } } })),
    retry: false,
  });

export const brokerCallsQuery = (orgId: string) =>
  queryOptions({
    queryKey: ["orgs", orgId, "broker-calls"],
    queryFn: () => unwrap(api.GET("/api/orgs/{org_id}/broker-calls", { params: { path: { org_id: orgId, limit: null } } })),
    refetchInterval: 30_000,
    retry: false,
  });

/** Oldest first. */
export const pendingQuestionsQuery = (orgId: string) =>
  queryOptions({
    queryKey: ["orgs", orgId, "questions", "pending"],
    queryFn: () => unwrap(api.GET("/api/orgs/{org_id}/questions", { params: { path: { org_id: orgId, status: null } } })),
    refetchInterval: 15_000,
    retry: false,
  });
